// Apollo
import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';

// Update
import UpdateReferee from '@/graphql/referees/update/updateReferee.gql';
import InsertReferees from '@/graphql/referees/insert/insertReferees.gql';
import DeleteReferee from '@/graphql/referees/delete/deleteReferee.gql';

export default {
	state: {
		referees: [] as Referee[],
	},

	// ================ Getters ================
	getters: {
		referees(state: any) {
			const referees = state.referees;
			referees.sort((refereeA: any, refereeB: any) => {
				if (refereeA.first_name > refereeB.first_name) return 1;
				if (refereeA.first_name < refereeB.first_name) return -1;
				return 0;
			});
			return referees;
		},
	},

	// ================ Mutations ================
	mutations: {
		setReferees(state: any, referees: any) {
			state.referees = referees;
		},
	},

	// ================= Actions =================
	actions: {
		async getReferees({ commit }: any) {
			const response = await apolloClient.query({
				query: gql`
					query MyQuery {
						referees {
							id
							first_name
							last_name
							phone_number
							email
							city
							cityByCity {
								country {
									id
								}
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});

			const { referees } = response.data;
			commit('setReferees', referees);
			return;
		},

		async insertReferee({ dispatch }: any, payload: any) {
			console.log('inserting ref...');
			const objects = [
				{
					first_name: payload.firstName || null,
					last_name: payload.lastName || null,
					phone_number: payload.phoneNumber || null,
					email: payload.email || null,
					city: payload.city || null,
				},
			];

			console.log(objects);

			await apolloClient
				.mutate({
					mutation: InsertReferees,
					// Parameters
					variables: {
						objects,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			dispatch('getReferees');
			return;
		},

		async deleteReferee({ dispatch }: any, payload: any) {
			const { id } = payload;
			await apolloClient
				.mutate({
					mutation: DeleteReferee,
					// Parameters
					variables: {
						refereeId: id,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			dispatch('getReferees');
			return;
		},

		async updateReferee({ dispatch }: any, payload: any) {
			const { firstName, lastName, phoneNumber, email, city, id } = payload;
			await apolloClient.mutate({
				mutation: UpdateReferee,
				// Parameters
				variables: {
					refereeId: id,
					firstName,
					lastName,
					phoneNumber,
					email,
					city,
				},
			});

			dispatch('getReferees');
			return;
		},
	},
};
